import React, { useState, useEffect} from 'react';
import './avatar.css'
import SVG from '../../svg/Svg';

const HeaderImage = ({ imageUrl, menuUrl, Click }) => {
  const [isImageError, setIsImageError] = useState(false);

  useEffect(() => {
    // каждый раз при смене URL сбрасываем ошибку
    setIsImageError(false);
  }, [imageUrl]);

  return (
    <div
      className="header-image-container"
      onClick={Click}
    >
      {isImageError ? (
        <div>{SVG['defaultAva']}</div>
      ) : (
        <img
          src={imageUrl}
          alt="Header_Image"
          className="header-image"
          onLoad={() => setIsImageError(false)}
          onError={() => setIsImageError(true)}
        />
      )}
      <div
        src={menuUrl}
        alt="Menu_Image"
        className="menu-image"
      >
        {SVG['mark']}
      </div>
    </div>
  );
};

export default HeaderImage;
